<h1 mat-dialog-title>Modifier un compte en banque</h1>
<form mat-dialog-content [formGroup]="bankForm" (ngSubmit)="bankForm.valid && onSubmit()">
  <div class="column">
    <div class="row">
      <mat-form-field>
        <mat-label>Nom*</mat-label>
        <input matInput formControlName="name" autocomplete="off">
      </mat-form-field>
      <mat-form-field>
        <mat-label>Devise*</mat-label>
        <mat-select matInput formControlName="devise" autocomplete="off">
          <mat-option *ngFor="let devise of this.devises" [value]="devise">
            {{devise}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="row">
      <mat-form-field>
        <mat-label>IBAN*</mat-label>
        <input matInput formControlName="iban" autocomplete="off" (change)="onIbanChange()">
        <mat-error *ngIf="ibanControl.invalid" [matTooltip]="getIbanErrorMessage()">{{ getIbanErrorMessage() }}</mat-error>
      </mat-form-field>
      <mat-form-field>
        <mat-label>BIC*</mat-label>
        <input matInput formControlName="bic" autocomplete="off">
        <mat-error *ngIf="bicControl.invalid" [matTooltip]="getBicErrorMessage()">{{ getBicErrorMessage() }}</mat-error>
      </mat-form-field>
    </div>
    <div class="row">
      <mat-form-field>
        <mat-label>Date de début d'utilisation*</mat-label>
        <input matInput formControlName="startDate" [matDatepicker]="startDatepicker" (dateChange)="updateEndDate()">
        <mat-datepicker-toggle matSuffix [for]="startDatepicker"></mat-datepicker-toggle>
        <mat-datepicker #startDatepicker></mat-datepicker>
      </mat-form-field>
      <mat-form-field>
        <mat-label>Date de fin d'utilisation</mat-label>
        <input matInput formControlName="endDate" [matDatepicker]="endDatepicker" [min]="minDate">
        <mat-datepicker-toggle matSuffix [for]="endDatepicker"></mat-datepicker-toggle>
        <mat-datepicker #endDatepicker></mat-datepicker>
      </mat-form-field>
    </div>
    <div class="validate">
      <button mat-button mat-dialog-close type="button">Annuler</button>
      <button mat-button mat-dialog-close color="warn" type="button" (click)="deleteAccount()">Supprimer</button>
      <button mat-button color="primary" type="submit" [disabled]="bankForm.invalid">Modifier</button>
    </div>
  </div>
</form>







